import Swiper, { Pagination, Navigation } from 'swiper';
import 'swiper/css/pagination';

export default (swiperId, enableDrag, paginationType = 'bullets') => ({
    init() {
        const slider = document.getElementById('gallery_slider_' + swiperId);
        if (slider != null) {
            if (!slider.classList.contains('swiper-initialized')) {
                this.swiper = new Swiper(slider, this.getSliderOptions());
            }
        }
    },

    getSliderOptions() {
        const paginationOptions = {
            el: '.image-slider-pagination-' + swiperId,
            type: paginationType === 'fraction' ? 'fraction' : 'bullets',
            dynamicBullets: paginationType === 'bullets' ? true : false,
            dynamicMainBullets: 3,
        };

        return {
            preloadImages: true,
            loop: false,
            observer: true,
            observeParents: true,
            lazy: true,
            slidesPerView: 1,
            resistance: true,
            resistanceRatio: 0,
            watchOverflow: true,
            grabCursor: true,
            modules: [Pagination, Navigation],
            allowTouchMove: enableDrag,
            pagination: paginationOptions,
            navigation: {
                nextEl: '.next-image-slider-' + swiperId,
                prevEl: '.prev-image-slider-' + swiperId,
            },
        };
    },
});
